import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Button } from 'react-bootstrap';

import TableButtonCell from '../TableButtonCell';

const TableCopyCell = ({ itemList, copyItem, itemID }) => {
  const copyItemFunction = () => {
    if (isEmpty(itemList)) copyItem(itemID);
    else copyItem(itemList, itemID);
  };
  return (
    <TableButtonCell>
      <Button size="sm" variant="info" onClick={copyItemFunction}>
        Copy
      </Button>
    </TableButtonCell>
  );
};

TableCopyCell.propTypes = {
  itemList: PropTypes.string.isRequired,
  itemID: PropTypes.string.isRequired,
  copyItem: PropTypes.func.isRequired
};

export default TableCopyCell;
